<div class="osusume-carousel-container">
  <div class="osusume-carousel" #carousel>
    <ng-content></ng-content>
  </div>
</div>
